import { BROADCAST_QUEUE_STAGE_LAYOUT } from 'actions/Types';

export default layout => {
  return dispatch => {
    const action = {
      type: BROADCAST_QUEUE_STAGE_LAYOUT,
      payload: layout
    };

    dispatch(action);
  };
};
